<template>
  <div class="empr">
    <!-- <VueSlickCarousel
      :dots="true"
      class="empr__carousel"
      :autoplay="true"
      :autoplaySpeed="5000"
      :arrows="false"
    >
      <div class="empr__hero empr__hero--1">
        <div class="left">
          <h1>
            Shark Tank Colombia <br />
            presenta DiDi Lab. <br />
            <span> Laboratorio de ideas para la reactivación del país.</span>
          </h1>
        </div>
        <div></div>
      </div>
      <div class="empr__hero empr__hero--2">
        <div class="left"></div>
        <div></div>
      </div>
      <div class="empr__hero empr__hero--3">
        <div class="left"></div>
        <div></div>
      </div>
    </VueSlickCarousel> -->

    <div class="empr__hero">
      <div class="left">
        <h1>
          <span>Conoce mejor a los</span><br />
          6 emprendimentos semifinalistas
        </h1>
      </div>
      <div></div>
    </div>

    <h2 class="empr__titulo">SEMIFINALISTAS</h2>

    <div class="empr__emprendimientos" v-if="postulaciones.length > 0">
      <div
        class="empr__emprendimientos__emprendimiento"
        v-for="(postulacion, i) in postulaciones"
        :key="i"
      >
        <!-- <img
          :src="require(`../assets/images/semifinalists/${postulacion.image}`)"
          :alt="postulacion.name"
        /> -->
        <iframe
          :src="postulacion.video"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
        <div class="empr__emprendimientos__emprendimiento__textos">
          <p class="empr__emprendimientos__emprendimiento__textos__titulo">
            {{ postulacion.name }} | {{ postulacion.owner }}
          </p>
          <p class="empr__emprendimientos__emprendimiento__textos__descripcion">
            {{ postulacion.text }}
          </p>
        </div>
      </div>
    </div>

    <p class="empr__no-emprendedores" v-else>Aún no hay emprendedores</p>

    <Allies />
  </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import Allies from "@/components/Allies.vue";
import Modal from "@/components/Modal.vue";

export default {
  components: {
    VueSlickCarousel,
    Allies,
    Modal,
  },
  data() {
    return {
      postulaciones: [
        {
          name: "Planet Oliver",
          owner: "Manuel Oliva",
          text:
            "A través de su marketplace, Planet Oliver permite comercializar los productos  que supermercados, restaurantes y cafeterías no alcanzaron a vender.",
          image: "planet_oliver.jpg",
          video: "https://www.youtube.com/embed/yWfZoDIEjtw",
        },
        {
          name: "Wolke Kumpels",
          owner: "Natalia Medina",
          text:
            "Su emprendimiento  le permite a las entidades prestadoras de salud  identificar, mediante un software, errores en la medicación de pacientes y disminuir los costos asociados.",
          image: "wolke_kumpel.jpg",
          video: "https://www.youtube.com/embed/G35o-vPe9OY",
        },
        {
          name: "Griky",
          owner: "Andrés Núñez",
          text:
            "Su emprendimiento GRIKY es una plataforma de aprendizaje digital con alcance a todo América Latina",
          image: "griky.jpg",
          video: "https://www.youtube.com/embed/rnf_5jYmWPw",
        },
        {
          name: "Quick Domi",
          owner: "Jhojan Stiven Garner",
          text:
            "A través de su emprendimiento ayuda a establecimientos comerciales de la localidad 7 de Bogotá a conectarse directamente con los clientes.",
          image: "quick_domi.jpg",
          video: "https://www.youtube.com/embed/pY74A7ZvMis",
        },
        {
          name: "Akirento",
          owner: "Diego Araque",
          text:
            "A través de su emprendimiento Akirento le permite a las personas poner en alquiler sus productos en línea",
          image: "akirento.jpg",
          video: "https://www.youtube.com/embed/1mGgmD8qLaI",
        },

        {
          name: "BAGCYCLE",
          owner: "David García",
          text:
            "Su emprendimiento desarrolla bicicletas económicas, plegables y portables en una maleta, a partir de plástico reciclado.",
          image: "bagcycle.jpg",
          video: "https://www.youtube.com/embed/r5RyIea1QAI",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.empr {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: url("../assets/images/bg.jpg") no-repeat;
  background-size: cover;
  background-position-y: 45%;

  &__carousel {
    width: 100%;
  }

  // &__hero {
  //   height: 70vh;
  //   width: 100%;
  //   padding: 2rem 4rem;
  //   display: grid !important;

  //   @include phone {
  //     padding: 1rem 2rem;
  //     height: 30vh;
  //   }

  //   &--1 {
  //     background: url("../assets/images/home/hero_2_2.jpg") no-repeat;
  //     background-size: cover;
  //     grid-template-columns: 40% 60%;

  //     @include phone {
  //       grid-template-columns: 60% 40%;
  //     }
  //   }
  //   &--2 {
  //     background: url("../assets/images/home/hero_1_2.jpg") no-repeat;
  //     background-size: cover;
  //     grid-template-columns: 50% 50%;

  //     @include phone {
  //       grid-template-columns: 80% 20%;
  //     }
  //   }
  //   &--3 {
  //     background: url("../assets/images/home/hero_3_2.jpg") no-repeat;
  //     background-size: cover;
  //     grid-template-columns: 60% 40%;

  //     @include phone {
  //       grid-template-columns: 80% 20%;
  //     }
  //   }

  //   .left {
  //     height: 100%;
  //     display: flex;
  //     flex-direction: column;
  //     justify-content: flex-end;
  //     h1 {
  //       color: white;

  //       @include phone {
  //         font-size: 0.8rem;
  //         width: 100%;
  //       }

  //       span {
  //         font-weight: 100;
  //       }
  //     }
  //   }
  // }

  &__hero {
    width: 100%;
    padding: 2rem 4rem;
    display: grid !important;
    height: 45vh;
    background: url("../assets/images/home/hero_4.jpg") no-repeat;
    background-size: cover;
    grid-template-columns: 60% 40%;

    @include phone {
      padding: 1rem 2rem;
      height: 20vh;
      background: url("../assets/images/home/hero_4.jpg") 50% 50% no-repeat;
      background-size: cover;
    }

    .left {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      h1 {
        color: white;

        @include phone {
          font-size: 0.8rem;
          width: 100%;
        }

        span {
          font-weight: 100;
        }
      }
    }
  }

  &__titulo {
    margin: 2rem auto 4rem auto;
    text-align: center;
    color: white;
  }

  &__emprendimientos {
    width: 90%;
    margin: 0 auto 6rem auto;
    max-width: 1200px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 3rem;

    @include phone {
      grid-template-columns: repeat(1, 1fr);
    }

    &__emprendimiento {
      background-color: rgba($color: #ffffff, $alpha: 0.35);

      img {
        width: 100% !important;
        height: auto;
      }

      iframe {
        width: 100%;
      }

      &__textos {
        padding: 10px;

        &__titulo {
          color: white;
          margin-bottom: 1rem;
        }

        &__descripcion {
          color: white;
          font-weight: 100;
          font-size: 0.8rem;
        }
      }

      button {
        background-color: $main-color;
        padding: 5px 20px;
        color: #ffffff;
        border: 2px solid #707070;
        border-radius: 20px;
        font-size: 0.8rem;
        display: block;
        margin: 0 auto 1rem auto;
      }
    }
  }

  &__no-emprendedores {
    color: white;
    margin-bottom: 3rem;
  }
}
</style>